// extracted by mini-css-extract-plugin
module.exports = {"count":"global-header-right_count_lQz8P","searchSelect":"global-header-right_searchSelect_2h8tq"};